import dayjs from 'dayjs';
import { View } from '@react-pdf/renderer';
import { en } from '../../theme/languages/en';
import { Span } from '..';
import { creditNoteReasonCodesLabels } from '../../../credit';
import { CreditNote } from '../../../credit/interfaces/credit-note-interface';
import { DATE_FORMAT_SLASH } from '../../utils/invoiceTable';
import { getCreditNoteIdName } from '../../utils';
import { styles } from '../InvoiceMetaData/InvoiceMetaData.module';

interface CreditNoteMetaDataProps {
  className?: {};
  creditNoteData: CreditNote;
  title?: string;
}

export const CreditNoteMetaData = ({
  creditNoteData,
  className,
  title = en.creditNotePreview,
}: CreditNoteMetaDataProps) => {
  return (
    <View style={className}>
      <View style={styles.invoiceDetails}>
        {creditNoteData?.poNumber && <Span style={styles.po}>{creditNoteData?.poNumber}</Span>}
        <Span style={styles.mainTitle}>{title}</Span>

        <View style={styles.detailsContainer}>
          <View style={styles.detailsSection}>
            <Span style={styles.detailsTitle}>{en.creditTo}</Span>
            <Span style={styles.text}>{creditNoteData?.customer?.legalName}</Span>
            <Span style={styles.text}>{creditNoteData?.customer?.billingAddress}</Span>
            <Span style={styles.text}>{creditNoteData?.customer?.city}</Span>
            <Span style={styles.text}>{creditNoteData?.customer?.countryState}</Span>
            <Span style={styles.text}>{creditNoteData?.customer?.country}</Span>
          </View>

          <View style={[styles.detailsSection, { marginLeft: 80 }]}>
            <View style={styles.textContainer}>
              <Span style={styles.detailsTitle}>{en.creditNoteNo}</Span>
              <Span
                style={styles.text}
                canBeMissingValue
                missingValue={creditNoteData?.documentNumber || creditNoteData?.draftNumber}
                placeholder={en.draft}
              >
                {getCreditNoteIdName(creditNoteData) || en.draft}
              </Span>
            </View>

            <View style={styles.textContainer}>
              <Span style={styles.text}>{`${en.issueDate}:`}</Span>
              <Span style={styles.text}>{dayjs(creditNoteData?.issueDate).format(DATE_FORMAT_SLASH)}</Span>
            </View>

            <View style={styles.textContainer}>
              <Span style={styles.text}>{`${en.reasonCode}:`}</Span>
              <Span style={styles.text} canBeMissingValue missingValue={creditNoteData?.reasonCode} placeholder={'-'}>
                {creditNoteReasonCodesLabels[creditNoteData?.reasonCode]}
              </Span>
            </View>

            {creditNoteData?.contractId && (
              <View style={styles.textContainer}>
                <Span style={styles.text}>{`${en.creditPeriod}:`}</Span>
                <Span style={styles.text}>{`${dayjs(creditNoteData?.pricingModel?.tabs[0]?.billingStartDate).format(
                  DATE_FORMAT_SLASH,
                )} - ${dayjs(creditNoteData?.pricingModel?.tabs[0]?.billingEndDate).format(DATE_FORMAT_SLASH)}`}</Span>
              </View>
            )}
          </View>
        </View>
      </View>
    </View>
  );
};
